import { ReactComponent as PdfIcon } from '@shared/assets/icons/ic-pdf-icon.svg'
import { ReactComponent as DocIcon } from '@shared/assets/icons/ic-file-doc.svg'
import { AudioLinesIcon, FileIcon, VideoIcon, ImageIcon } from 'lucide-react'
import { cn } from 'lib/utils'

const RenderFileIcon = ({ fileType, size = 16 }: { fileType: string; size?: number }) => {
  const className = cn('flex-shrink-0', size && `w-[${size}px] h-[${size}px]`)

  switch (fileType) {
    case 'pdf':
      return <PdfIcon className={className} />
    case 'jpg':
    case 'jpeg':
      return <ImageIcon className={className} />
    case 'mp4':
      return <VideoIcon className={className} />
    case 'mp3':
      return <AudioLinesIcon className={className} />
    case 'xlsx':
    case 'txt':
    case 'doc':
      return <DocIcon className={className} />
    default:
      return <FileIcon className={className} />
  }
}

export default RenderFileIcon
